import "./Header.css";
import Navbar from "../Navbar/Navbar";
import Menu from "../Menu/Menu";

function Header() {
  return (
    <div>
      <Navbar />
      <Menu />
    </div>
  );
}


export default Header;